// User 정보

export const SET_USER_INFO = 'SET_USER_INFO'
export function setUserInfo(userInfo) {
    return {
        type: SET_USER_INFO,
        userInfo,
    }
}

export const SET_IS_LOGIN = 'SET_IS_LOGIN'
export function setIsLogin(isLogin) {
    return {
        type: SET_IS_LOGIN,
        isLogin,
    }
}

export const SET_LOADING = 'SET_LOADING'
export function setLoading(isLoading) {
    return {
        type: SET_LOADING,
        isLoading,
    }
}
export const SET_EVT_OPTION = 'SET_EVT_OPTION'
export function setEvtOption(opt) {
    return {
        type: SET_EVT_OPTION,
        opt,
    }
}
export const SET_PLN_OPTION = 'SET_PLN_OPTION'
export function setPlnOption(opt) {
    return {
        type: SET_PLN_OPTION,
        opt,
    }
}
export const SET_ALL_OPTION = 'SET_ALL_OPTION'
export function setAllOption(opt) {
    return {
        type: SET_ALL_OPTION,
        opt,
    }
}
export const SET_CART_ITEM = 'SET_CART_ITEM'
export function setCartItem(cartItem) {
    return {
        type: SET_CART_ITEM,
        cartItem,
    }
}
